import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "w100p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$whitelabel.brand) + " needs your approval to use your personnal and banking information, in order for you to use our platform for buying our products. "), _c("div", [_vm.stateError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(_vm._s(_vm.stateError))]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.toLogin();
      }
    }
  }, [_vm._v("Refuse")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.connect();
      }
    }
  }, [_vm._v("Accept")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };